
import { Component, Prop } from 'vue-property-decorator'

import { Mixins } from 'vue-mixin-decorator'
import MixinInterface from '@/_mixins/index'
import ProjectMixin from '@/_mixins/project'

import WidgetTemplate from '@/views/Project/Dashboard/components/widget.vue'
import Contact from '@/views/Project/HSE/components/contact/contact.vue'
import ProjectFilter from '@/views/Project/components/project.vue'

@Component({
    name: 'HSEContactWidget',
    mixins: [ProjectMixin],
    components: { WidgetTemplate, Contact, ProjectFilter },
})
export default class HSEContactWidget extends Mixins<MixinInterface>(ProjectMixin) {
    @Prop({ required: true }) component!: any
    @Prop({ required: true }) dashboardId!: string
    @Prop({ default: false }) isPublic!: boolean

    get isProjectGroupView() {
        return this.$route.params.type == 'g'
    }

    get permissionRequired() {
        return this.isPublic ? 'hse.view_public_hse_board' : 'hse.view_hse_board'
    }

    get projectId() {
        return this.dashboardViewType
            ? this.component?.settings[this.dashboardViewType].project
                ? this.component?.settings[this.dashboardViewType].project
                : this.component?.settings.default.project
            : null
    }

    set projectId(data) {
        this.component.settings[this.viewType].project = data
        let widgets = JSON.parse(JSON.stringify(this.$store.getters.widgetsData))
        let widget = widgets[this.component.id]
        widget.settings[this.viewType].project = data
        this.$store.commit('widgetsData', widgets)
    }

    get project() {
        return this.projectId ? this.$store.getters.project(this.projectId) : null
    }

    get HSEContacts() {
        return this.project
            ? this.isPublic
                ? this.project.relationships.hseContacts.data.filter((item: any) => {
                      return this.$store.getters.hseContact(item.id).attributes.isPublic
                  })
                : this.project.relationships.hseContacts.data
            : null
    }

    get activeModules() {
        return Object.values(this.$store.getters.projectModules)
    }

    isModuleAccessible(name: string) {
        return (
            this.activeModules.findIndex((module: any) => {
                return (
                    module?.attributes.isAccessible && module.relationships.module.data.id == name
                )
            }) > -1
        )
    }
}
